module.exports = __webpack_public_path__ + "img/31.f1650f43.svg";